import { doGet, doPost } from 'hooks/requests';

export const useNotificationsService = () => {
    const getNotifications = async ({ companyId, page = 1, pageSize = 10 }) => {
        const response = await doGet(`/notifications/${companyId}/`);
        return response;
    };

    const markNotificationAsRead = async ({ companyId, notificationId }) => {
        const response = await doPost(`/notifications/${companyId}/${notificationId}/read/`);
        return response;
    };

    return {
        getNotifications,
        markNotificationAsRead,
    };
};
